export const buildEmbeddedApplicationUrl = ({
  link,
  params,
  locale,
}: {
  link: string;
  params?: string;
  locale: string;
}): string => {
  const url = new URL(link, window.location.href);
  const configuredParams = new URLSearchParams((params ?? '').replace(/^[?&]+/, ''));
  configuredParams.forEach((value, key) => url.searchParams.set(key, value));
  if (!url.searchParams.has('locale')) {
    url.searchParams.set('locale', locale);
  }
  return url.toString();
};
